import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { ChevronLeftIcon } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface LocationState {
  from?: string;
}

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const t = useTranslation();

  const handleBackClick = () => {
    const state = location.state as LocationState;
    if (state && state.from) {
      navigate(state.from);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button variant="default" onClick={handleBackClick}>
      <ChevronLeftIcon className="mr-2 h-4 w-4" />
      {t.SHARED.LABELS.BACK_BUTTON}
    </Button>
  );
}
